import React from "react";
import { ModalCrosSvg } from "../../../images/Svgs";
import { formatAMPM, formatDate } from "../../../utils/common";
const TransactionDetail = ({ transactionDetail, onModalClose }) => {
  return (
    <div className="modal fade show">
      <div className="modal-dialog add_new_event_box transaction_modal">
        <div className="modal-content">
          <div className="modal-header">
            <h1
              className="modal-title fs-5 font-18 text-capitalize"
              id="exampleModalLabel"
            >
              Transaction Detail
            </h1>
            <button
              type="button"
              className="new_event_lose inter"
              onClick={() => onModalClose({ open: false })}
            >
              <ModalCrosSvg />
            </button>
          </div>
          <div class="modal-body">
            <div class="row gx-5">
              <div class="col-md-6 col-12">
                <div class="day_time">
                  <div class="entry_title_transaction">
                    <div className="d-flex gap-5 justify-content-between">
                      <span className="label_transaction">Name</span>
                      <span className="value_transaction">
                        {transactionDetail?.user?.first_name || "-"}{" "}
                        {transactionDetail?.user?.last_name || "-"}
                      </span>
                    </div>
                    <div className="d-flex gap-5 justify-content-between">
                      <span className="label_transaction">Email</span>
                      <span className="value_transaction">
                        {transactionDetail?.payer_email_address || "-"}
                      </span>
                    </div>
                    <div className="d-flex gap-5 justify-content-between">
                      <span className="label_transaction">Payer Id</span>
                      <span className="value_transaction">
                        {transactionDetail?.payer_id || "-"}
                      </span>
                    </div>
                    <div className="d-flex gap-5 justify-content-between">
                      <span
                        className="label_transaction"
                      >
                        Payment Status
                      </span>
                      <span className="value_transaction ">
                        {transactionDetail?.payment_status || "-"}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-6 col-12">
                <div class="day_time">
                  <div class="entry_title_transaction">
                    <div className="d-flex gap-5 justify-content-between">
                    <span className="label_transaction">Event Title</span>
                    <span className="value_transaction">
                        {transactionDetail?.event?.event_title || "-"}
                      </span>
                    </div>
                    <div className="d-flex gap-5 justify-content-between">
                    <span className="label_transaction">Event Location</span>
                    <span className="value_transaction">
                        {transactionDetail?.event?.event_location || "-"}
                      </span>
                    </div>
                    <div className="d-flex gap-5 justify-content-between">
                    <span className="label_transaction">Transaction Id</span>{" "}
                    <span className="value_transaction">{transactionDetail?.transaction_id || "-"}</span>
                    </div>
                    <div className="d-flex gap-5 justify-content-between">
                    <span className="label_transaction">Amount</span>
                    <span className="value_transaction">${transactionDetail?.amount || "-"}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TransactionDetail;
